import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ApiRequestError } from './lib/api';
import { DialogProvider } from './components/ui/DialogProvider';
import { ToastProvider } from './components/ui/ToastProvider';
import { router } from './router';
import { ThemeProvider } from './theme/ThemeContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Don't retry auth/permission errors or a dead API; retry transient ones once.
        if (error instanceof ApiRequestError && (error.status === 0 || error.status >= 400)) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * ThemeProvider is outermost so every tree gets the theme: the agency app, sign-in, the approval
 * portal and the guides. The signed-in user's saved choice is adopted inside the agency tree
 * (ThemeServerSync in router.tsx).
 *
 * ToastProvider holds the app's one save toast ("Changes saved"), outside the router like the dialogs,
 * so every page and every dialog can confirm a save with useToast().
 */
export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <DialogProvider>
            <RouterProvider router={router} />
          </DialogProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
